// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1bgdZ","list":"PatternAutocomplete_list__-mjZo"};